import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import {StudiesTypedValue} from 'notebook/tables/typed-values/TypedValueTypes';

import {StudySearchItem} from './StudySearchInput';

/**
 * Transforms the StudySearchInput's response shape into a {@link StudiesTypedValue}.
 */
export function toStudiesTypedValueFromSearchItems(studies: Array<StudySearchItem>): StudiesTypedValue {
  return {
    type: BaseTypedValueType.STUDIES,
    studies: studies.map((study) => ({
      id: study.id,
      humanId: study.humanId,
      name: study.name,
    })),
  };
}

/**
 * Coerces the given {@link TypedValue} into a shape compatible with StudySearchInput.
 *
 * If `typedValue` is a {@link StudiesTypedValue}, extracts the values.
 * Otherwise, an empty list is returned.
 */
export function toStudySearchItemsFromTypedValue(typedValue: TypedValue | null): Array<StudySearchItem> {
  return typedValue?.type === BaseTypedValueType.STUDIES ? typedValue.studies : [];
}
